import React, { useState } from 'react';
import { BillConceptos, FiscalpopImpuesto } from '../../../models/Factura';
import Button from '../../Forms/Button';
import { useQuery } from '@apollo/react-hooks';
import { graphqlSchema } from '../../../services/graphql.schema';
import Pagination from '../../Forms/Pagination';
import { SPLIT_IMPUESTO_UNIQUE_ID } from '../../../utils/impuestos.formatting';
import { ConceptoElement } from './Factura.concepto.element';
import { EMPTY_CONCEPTO } from './Factura.conceptos.empty';

interface FacturarConceptoProps {
    conceptos: BillConceptos[];
    validRequested: boolean;
    authToken: string;
    isGlobalBill?: boolean;
    // Emitters
    onCfdiChange: (value: BillConceptos[]) => void;
    onValidationTest?: (valid: boolean) => void

}


const ITEMS_PER_PAGE = 10;

function FacturarConceptos({
    conceptos,
    onCfdiChange,
    validRequested,
    authToken,
    isGlobalBill,
    onValidationTest }: FacturarConceptoProps) {

    const [impuestosList, setImpuestosList] = useState([]);

    // Validation check (Sets do not need to be re-constructed)
    const [validUnidades] = useState<Set<string>>(new Set());
    const [validClaves] = useState<Set<string>>(new Set());

    // Pagination
    const [page, setPage] = useState(1);

    useQuery(graphqlSchema.FISCALPOP.IMPUESTOS.getImpuestos, {
        onCompleted: ({ getImpuestos }: { getImpuestos: FiscalpopImpuesto[] }) => {
            // Some taxes have traslado and retention at the same time, we need to split them
            const splitImpuestos = SPLIT_IMPUESTO_UNIQUE_ID(getImpuestos);
            // console.log('Get Impuestos: ', splitImpuestos);
            setImpuestosList(splitImpuestos);
        },
        onError: (e) => {
            console.error('Error loading impuestos: ', e);
        },
        fetchPolicy: 'cache-first'
    })

    const updateConceptoElement = (index: number) => (update: BillConceptos) => {
        const conceptosCommon = conceptos;
        conceptosCommon[index] = update;
        onCfdiChange(conceptosCommon);
    }

    const reportValidation = () => {
        const allValid = conceptos.every((concepto, i) => {
            const validUnidad = validUnidades.has(concepto.claveUnidad);
            const validClave = validClaves.has(concepto.claveProdServ);
            return validUnidad && validClave;
        })
        if (onValidationTest) {
            onValidationTest(allValid);
        }
    }

    const onConceptoValidationTest = (validUnidad: string, validClave: string) => {
        if (validUnidad) {
            validUnidades.add(validUnidad);
        }
        if (validClave) {
            validClaves.add(validClave);
        }
        reportValidation();
    }

    const addNewConcepto = () => {
        const conceptosCommon = conceptos;
        conceptosCommon.push(EMPTY_CONCEPTO(isGlobalBill));
        onCfdiChange(conceptosCommon);
        setPage(Math.ceil(conceptosCommon.length / ITEMS_PER_PAGE))
        reportValidation();
    }

    const removeConcepto = (index: number) => () => {
        const conceptosCommon = conceptos;
        conceptosCommon.splice(index, 1);
        onCfdiChange(conceptosCommon);
        setPage(Math.ceil(conceptosCommon.length / ITEMS_PER_PAGE))
        reportValidation();
    }

    return (
        <div>
            <h4>Conceptos</h4>
            <div className="card table">
                <div className="cardBody">
                    {
                        conceptos
                            .map((_, i) => ({ i, concepto: _ }))
                            .filter(({ i }) => (i >= (ITEMS_PER_PAGE * (page - 1))) && (i <= (ITEMS_PER_PAGE * page)))
                            .map(({ concepto, i }) =>
                            //conceptos.filter((_, i) => (i >= (ITEMS_PER_PAGE * (page - 1))) && (i < (ITEMS_PER_PAGE * page))).map((concepto, i) =>
                            (
                                <ConceptoElement
                                    key={i}
                                    isGlobalBill={!!isGlobalBill}
                                    concepto={concepto}
                                    conceptoIndex={i}
                                    authToken={authToken}
                                    removeConcepto={removeConcepto}
                                    validRequested={validRequested}
                                    impuestosList={impuestosList}
                                    handleConceptoUpdate={updateConceptoElement}
                                    onValidationTest={onConceptoValidationTest} />
                            )
                            )
                    }
                    <Pagination page={page} pages={Math.ceil(conceptos.length / ITEMS_PER_PAGE)} onPage={setPage} />
                    <div className="row">
                        <Button tertiary={true} handleClick={addNewConcepto}>
                            <span>Agregar otro concepto</span>
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FacturarConceptos;
